import { MediaAnalysisTarget } from '@/common/model/media/mediaAnalysisTarget'

export const MediaAnalysisTargetApiPath = {
  LIST_ANALYSIS_TARGETS: '/api/sites/{site_id}/media/analysis-targets', // GET List
  GET_ANALYSIS_TARGET: '/api/sites/{site_id}/media/analysis-targets/{target_id}', // GET Get
  CREATE_ANALYSIS_TARGET: '/api/sites/{site_id}/media/analysis-targets', // POST Create
  UPDATE_ANALYSIS_TARGET: '/api/sites/{site_id}/media/analysis-targets/{target_id}', // PUT Update
  DELETE_ANALYSIS_TARGET: '/api/sites/{site_id}/media/analysis-targets/{target_id}' // DELETE Delete
}

export type MediaAnalysisTargetApiPath =
  (typeof MediaAnalysisTargetApiPath)[keyof typeof MediaAnalysisTargetApiPath]

export interface ListAnalysisTargetsVars {
  site_id: number
}

export interface GetAnalysisTargetVars {
  site_id: number
  target_id: number
}

export interface CreateAnalysisTargetVars {
  site_id: number
  name: string
  site_url: string
  keyword_include?: string | null
  keyword_exclude?: string | null
  competitor_domains: string[]
  own_brand?: string | null
  own_url?: string | null
  category?: string | null
  competitor_brands?: string[]
  competitor_urls?: string[]
}

export interface UpdateAnalysisTargetVars {
  site_id: number
  target_id: number
  name?: string
  site_url?: string
  keyword_include?: string | null
  keyword_exclude?: string | null
  competitor_domains?: string[]
  own_brand?: string | null
  own_url?: string | null
  category?: string | null
  competitor_brands?: string[]
  competitor_urls?: string[]
}

export interface DeleteAnalysisTargetVars {
  site_id: number
  target_id: number
}

export type ListAnalysisTargetsResponse = MediaAnalysisTarget[]
export type GetAnalysisTargetResponse = MediaAnalysisTarget
export type CreateAnalysisTargetResponse = MediaAnalysisTarget
export type UpdateAnalysisTargetResponse = MediaAnalysisTarget

export interface DeleteAnalysisTargetResponse {
  deleted: boolean
}
